export const inputCheckboxStandard = { id: 'test', text: 'Test' };
